// GLOBO V2 - Improved variant expand/collapse functionality
// Shows expand button ONLY when 5+ variants (not checking wrapping for now)

(function() {
    'use strict';

    // Configuration
    const CONFIG = {
        MAX_VISIBLE_VARIANTS: 4, // Show 4 variants by default
        MIN_VARIANTS_FOR_BUTTON: 5, // Show button only when 5+ variants
        CHECK_INTERVAL: 100,
        MAX_CHECKS: 20,
        RESIZE_DEBOUNCE: 250
    };

    // ===== UTILITY FUNCTIONS =====

    /**
     * Debounce function to limit execution rate
     */
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    // ===== MAIN FUNCTIONALITY =====

    /**
     * Initialize expand/collapse functionality for product page variants
     */
    function initializeSwatchExpander() {
        const productGroups = document.querySelectorAll('.gsw-list-products-group');

        productGroups.forEach(function(group) {
            // Skip if already processed
            if (group.classList.contains('swatch-expander-v2-processed')) {
                return;
            }

            // Get all variant items (excluding expand button AND already hidden items)
            const items = Array.from(group.querySelectorAll('.gsw-prg-item')).filter(
                item => !item.classList.contains('swatch-expand-button') &&
                        !item.classList.contains('hidden-swatch-item') &&
                        !item.classList.contains('gsw-prg-item-sold-out') &&
                        !item.classList.contains('gsw-prg-item-not-online-store') &&
                        item.style.display !== 'none'
            );

            if (items.length === 0) {
                return;
            }

            // Mark as processed
            group.classList.add('swatch-expander-v2-processed');

            // Check if we need expand button - ONLY based on count
            const shouldShowExpandButton = items.length >= CONFIG.MIN_VARIANTS_FOR_BUTTON;

            if (shouldShowExpandButton) {
                initializeExpandButton(group, items);
            }
        });
    }

    /**
     * Initialize expand button for a variant group
     */
    function initializeExpandButton(group, items) {
        // Remove existing button if any
        const existingButton = group.querySelector('.swatch-expand-button');
        if (existingButton) {
            existingButton.remove();
        }

        // Hide items beyond MAX_VISIBLE_VARIANTS
        for (let i = CONFIG.MAX_VISIBLE_VARIANTS; i < items.length; i++) {
            items[i].style.display = 'none';
            items[i].classList.add('hidden-swatch-item');
        }

        // Create expand button
        const expandButton = createExpandButton(group, items);

        // Insert button after the last visible item
        const lastVisibleItem = items[CONFIG.MAX_VISIBLE_VARIANTS - 1];
        if (lastVisibleItem && lastVisibleItem.nextSibling) {
            group.insertBefore(expandButton, lastVisibleItem.nextSibling);
        } else {
            group.appendChild(expandButton);
        }
    }

    /**
     * Create expand/collapse button
     */
    function createExpandButton(group, items) {
        const expandButton = document.createElement('div');
        expandButton.className = 'gsw-prg-item swatch-expand-button';

        // Get dimensions from the first swatch for consistency
        const dimensions = getSwatchDimensions(items[0]);

        // Calculate hidden items count
        const hiddenCount = items.length - CONFIG.MAX_VISIBLE_VARIANTS;

        // Build button HTML
        expandButton.innerHTML = `
            <div class="expand-btn-wrapper"
                 style="width:${dimensions.width};height:${dimensions.height};background:#F9FAFB;border:1px solid #ddd;
                        display:flex;align-items:center;justify-content:center;
                        cursor:pointer;box-sizing:border-box;transition:all 0.2s ease;">
                <div class="expand-text"
                     style="color:#000;font-size:14px;margin:0;padding:0;
                            text-align:center;transition:color 0.2s ease;">
                    +${hiddenCount}
                </div>
            </div>
        `;

        // Track expanded state
        let isExpanded = false;

        // Get button elements
        const buttonWrapper = expandButton.querySelector('.expand-btn-wrapper');
        const expandText = expandButton.querySelector('.expand-text');

        // Add click functionality
        buttonWrapper.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            isExpanded = toggleExpanded(group, expandButton, expandText, items, isExpanded, hiddenCount);
        });

        // Add hover effects
        addHoverEffects(buttonWrapper, expandText);

        return expandButton;
    }

    /**
     * Get swatch dimensions
     */
    function getSwatchDimensions(firstItem) {
        const firstSwatch = firstItem.querySelector('.swatch-anchor');
        let width = '50px';
        let height = '50px';

        if (firstSwatch) {
            const rect = firstSwatch.getBoundingClientRect();
            if (rect.width && rect.height) {
                width = rect.width + 'px';
                height = rect.height + 'px';
            }
        }

        return { width, height };
    }

    /**
     * Toggle expanded/collapsed state
     */
    function toggleExpanded(group, expandButton, expandText, items, currentState, hiddenCount) {
        const hiddenItems = group.querySelectorAll('.hidden-swatch-item');

        if (currentState) {
            // Collapse
            hiddenItems.forEach(item => {
                item.style.display = 'none';
            });

            // Move button back to original position
            const lastVisibleItem = items[CONFIG.MAX_VISIBLE_VARIANTS - 1];
            if (lastVisibleItem && lastVisibleItem.nextSibling) {
                group.insertBefore(expandButton, lastVisibleItem.nextSibling);
            }

            expandText.textContent = '+' + hiddenCount;
            return false;
        } else {
            // Expand
            hiddenItems.forEach(item => {
                item.style.display = '';
            });

            // Move button to end
            group.appendChild(expandButton);

            expandText.textContent = 'zwiń';
            return true;
        }
    }

    /**
     * Add hover and active effects to button
     */
    function addHoverEffects(buttonWrapper, expandText) {
        buttonWrapper.addEventListener('mouseenter', function() {
            this.style.background = '#e5e7eb';
            this.style.borderColor = '#999';
        });

        buttonWrapper.addEventListener('mouseleave', function() {
            this.style.background = '#F9FAFB';
            this.style.borderColor = '#ddd';
            expandText.style.color = '#000';
            this.style.transform = 'scale(1)';
        });

        buttonWrapper.addEventListener('mousedown', function() {
            this.style.transform = 'scale(0.95)';
        });

        buttonWrapper.addEventListener('mouseup', function() {
            this.style.transform = 'scale(1)';
        });
    }

    /**
     * Re-initialize on window resize (with debounce)
     */
    const handleResize = debounce(function() {
        // Remove processed markers
        document.querySelectorAll('.swatch-expander-v2-processed').forEach(group => {
            group.classList.remove('swatch-expander-v2-processed');

            // Remove existing buttons
            const existingButton = group.querySelector('.swatch-expand-button');
            if (existingButton) {
                existingButton.remove();
            }

            // Show all hidden items
            const hiddenItems = group.querySelectorAll('.hidden-swatch-item');
            hiddenItems.forEach(item => {
                item.style.display = '';
                item.classList.remove('hidden-swatch-item');
            });
        });

        // Re-initialize
        initializeSwatchExpander();
    }, CONFIG.RESIZE_DEBOUNCE);

    // ===== COLLECTION PAGE POSITIONING =====

    function handleCollectionPositioning() {
        const globoCollectionDivs = document.querySelectorAll('.globo-product-groups-collection:not(.positioned)');

        globoCollectionDivs.forEach(globoDiv => {
            globoDiv.classList.add('positioned');

            const productCard = globoDiv.closest('.product-item');
            if (!productCard) return;

            const cardTitle = productCard.querySelector('.card__heading');
            const cardWrapper = productCard.querySelector('.card-information__wrapper');
            const cardPrice = productCard.querySelector('.card-price');

            if (!cardTitle || !cardWrapper) return;

            function positionSwatches() {
                const isDesktop = window.innerWidth >= 1024;

                if (isDesktop) {
                    let titleWrapper = cardTitle.closest('.title-swatch-wrapper');
                    if (!titleWrapper) {
                        titleWrapper = document.createElement('div');
                        titleWrapper.className = 'title-swatch-wrapper';
                        cardTitle.parentNode.insertBefore(titleWrapper, cardTitle);
                        titleWrapper.appendChild(cardTitle);
                    }

                    if (!titleWrapper.contains(globoDiv)) {
                        titleWrapper.appendChild(globoDiv);
                    }
                } else {
                    if (cardPrice) {
                        if (cardPrice.nextSibling) {
                            cardWrapper.insertBefore(globoDiv, cardPrice.nextSibling);
                        } else {
                            cardWrapper.appendChild(globoDiv);
                        }
                    } else {
                        cardWrapper.appendChild(globoDiv);
                    }

                    const titleWrapper = cardTitle.closest('.title-swatch-wrapper');
                    if (titleWrapper && titleWrapper.contains(cardTitle)) {
                        titleWrapper.parentNode.insertBefore(cardTitle, titleWrapper);
                        if (titleWrapper.children.length === 0) {
                            titleWrapper.remove();
                        }
                    }
                }
            }

            positionSwatches();
            window.addEventListener('resize', positionSwatches);
        });
    }

    // ===== LEGEND REMOVAL =====

    function removeLegends() {
        const legends = document.querySelectorAll('.globo-product-groups-collection legend, .globo-product-groups-detail legend');
        legends.forEach(legend => {
            legend.style.display = 'none';
        });
    }

    // ===== INITIALIZATION =====

    function initialize() {
        // Remove legends
        removeLegends();

        // Initialize swatch expander
        initializeSwatchExpander();

        // Handle collection positioning
        handleCollectionPositioning();

        // Periodic checks
        let checkCount = 0;
        const quickCheck = setInterval(function() {
            initializeSwatchExpander();
            handleCollectionPositioning();
            removeLegends();
            checkCount++;
            if (checkCount > CONFIG.MAX_CHECKS) {
                clearInterval(quickCheck);
            }
        }, CONFIG.CHECK_INTERVAL);

        // Watch for DOM changes
        const observer = new MutationObserver(function(mutations) {
            let shouldProcess = false;

            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === Node.ELEMENT_NODE && (
                        node.querySelector('.gsw-list-products-group') ||
                        node.classList.contains('gsw-list-products-group') ||
                        node.querySelector('.globo-product-groups-collection') ||
                        node.classList.contains('globo-product-groups-collection')
                    )) {
                        shouldProcess = true;
                    }
                });
            });

            if (shouldProcess) {
                setTimeout(() => {
                    initializeSwatchExpander();
                    handleCollectionPositioning();
                    removeLegends();
                }, 200);
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        // Reinitialize on Shopify events
        document.addEventListener('shopify:section:load', function() {
            setTimeout(initializeSwatchExpander, 100);
        });

        document.addEventListener('product:variant:change', function() {
            setTimeout(initializeSwatchExpander, 100);
        });

        // Handle window resize
        window.addEventListener('resize', handleResize);
    }

    // Start when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize);
    } else {
        initialize();
    }

})();

// Additional CSS injection for globo-v2
(function() {
    const style = document.createElement('style');
    style.id = 'globo-v2-styles';
    style.textContent = `
        .swatch-expand-button {
            display: inline-block !important;
            visibility: visible !important;
            opacity: 1 !important;
        }
        .swatch-expand-button .expand-btn-wrapper {
            display: flex !important;
        }

        /* Hide legends */
        .globo-product-groups-collection legend,
        .globo-product-groups-detail legend {
            display: none !important;
        }

        /* Hide expand buttons ONLY on collection pages */
        .globo-product-groups-collection .swatch-expand-button {
            display: none !important;
        }

        .globo-product-groups-collection .expand-btn-wrapper {
            display: none !important;
        }

        /* Ensure product page expand buttons remain visible */
        .globo-product-groups-detail .swatch-expand-button {
            display: inline-block !important;
            visibility: visible !important;
            opacity: 1 !important;
        }

        .globo-product-groups-detail .expand-btn-wrapper {
            display: flex !important;
            visibility: visible !important;
            opacity: 1 !important;
        }

        /* Collection page styling */
        .title-swatch-wrapper {
            display: flex !important;
            justify-content: space-between !important;
            align-items: flex-start !important;
            gap: 8px !important;
            width: 100% !important;
            margin-bottom: 8px !important;
        }

        .title-swatch-wrapper .card__heading {
            flex: 1 1 auto !important;
            margin: 0 !important;
            text-align: left !important;
        }

        .title-swatch-wrapper .globo-product-groups-collection {
            flex: 0 0 auto !important;
            margin: 0 !important;
        }

        .globo-product-groups-collection .gsw-list-products-group {
            display: flex !important;
            flex-wrap: wrap !important;
            gap: 4px !important;
            align-items: center !important;
            margin: 0 !important;
            padding: 0 !important;
        }

        @media (min-width: 1024px) {
            .card-information__wrapper .card__heading {
                display: flex !important;
                justify-content: space-between !important;
                align-items: flex-start !important;
                gap: 6px !important;
                position: relative !important;
            }

            .card-information__wrapper .globo-product-groups-collection {
                position: static !important;
                margin-top: 0 !important;
                order: unset !important;
            }

            .card-information__wrapper .card__heading .card-title {
                flex: 1 !important;
            }
        }

        .globo-product-groups-collection .gsw-list-products-group {
            display: flex !important;
            flex-wrap: wrap !important;
            gap: 4px !important;
            justify-content: center !important;
            align-items: center !important;
            margin: 0 !important;
            padding: 0 !important;
        }

        .globo-product-groups-collection .gsw-prg-item {
            width: 22px !important;
            height: 22px !important;
            margin: 0 !important;
            padding: 0 !important;
        }

        .globo-product-groups-collection .swatch-anchor {
            width: 22px !important;
            height: 22px !important;
            border-radius: 50% !important;
            transition: all 0.2s ease !important;
            display: block !important;
        }

        .globo-product-groups-collection .gsw-prg-item--link:hover .swatch-anchor {
            border-color: #000 !important;
            transform: scale(1.15) !important;
            box-shadow: 0 2px 6px rgba(0,0,0,0.12) !important;
        }

        @media (max-width: 768px) {
            .globo-product-groups-detail .gsw-list-products-group {
                display: flex !important;
                flex-wrap: wrap !important;
                gap: 8px !important;
                padding: 4px 0 !important;
                width: 100% !important;
                box-sizing: border-box !important;
            }

            .globo-product-groups-detail .gsw-prg-item {
                flex: 0 0 70px !important;
                width: 70px !important;
                max-width: 70px !important;
                min-width: 70px !important;
                margin: 0 !important;
                padding: 0 !important;
                box-sizing: border-box !important;
            }

            .globo-product-groups-detail .gsw-prg-item--link,
            .globo-product-groups-detail .gsw-prg-item .swatch-anchor {
                width: 70px !important;
                height: 80px !important;
                max-width: 70px !important;
                max-height: 80px !important;
                display: block !important;
                margin: 0 !important;
                padding: 0 !important;
                box-sizing: border-box !important;
            }

            .globo-product-groups-detail .swatch-expand-button {
                flex: 0 0 70px !important;
                width: 70px !important;
                max-width: 70px !important;
                min-width: 70px !important;
                margin: 0 !important;
                padding: 0 !important;
                box-sizing: border-box !important;
            }

            .globo-product-groups-detail .swatch-expand-button .expand-btn-wrapper {
                width: 70px !important;
                height: 80px !important;
                min-width: 70px !important;
                min-height: 80px !important;
                box-sizing: border-box !important;
            }
        }

        @media (max-width: 1024px) {
            .title-swatch-wrapper {
                flex-direction: column !important;
                align-items: flex-start !important;
                gap: 8px !important;
            }

            .globo-product-groups-collection .gsw-list-products-group {
                justify-content: flex-start !important;
                gap: 3px !important;
            }

            .globo-product-groups-collection .gsw-prg-item {
                width: 20px !important;
                height: 20px !important;
            }

            .globo-product-groups-collection .swatch-anchor {
                width: 20px !important;
                height: 20px !important;
            }
        }

        @media (max-width: 768px) {
            .globo-product-groups-collection .gsw-prg-item {
                width: 18px !important;
                height: 18px !important;
            }

            .globo-product-groups-collection .swatch-anchor {
                width: 18px !important;
                height: 18px !important;
            }
        }
    `;

    // Remove old globo styles if they exist (to avoid conflicts)
    const oldStyles = document.querySelectorAll('style');
    oldStyles.forEach(oldStyle => {
        if (oldStyle.textContent.includes('swatch-expand-button') && oldStyle.id !== 'globo-v2-styles') {
            // Don't remove, just let new styles override
        }
    });

    document.head.appendChild(style);
})();
